import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MenuCard from './MenuCard';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import {
  fetchItemDetailsAction,
  addItemToFavouriteAction,
  addItemToUnFavouriteAction,
} from '@kfc-global/react-shared/redux/Actions/MenuAction';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import FoodItemListHandlers from 'organisms/CartPage/Presentation/ReusableComponents/FoodItemListHandlers';
import { UserOrderContext } from 'context/context';
import UserLocalization from './UserLocalization';
import {
  addItemToCartAction,
  showCustomizationModalAction,
  setUserLastActiveTime,
  updateItemQuantityAction,
  createBasketsAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import { jsontoObjects, getValueOrDefaultObject, dispatchCreateBasketsAction } from 'common/utilities/utils';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/Constants/MenuPDPPageConstants';
import { CAROUSEL_RESPONSIVE_SETTINGS } from 'common/constants/SharedConstants';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { PRODUCT_DETAILS } from 'organisms/MenusPLP/MenuPLPConstants/MenuPLPConstants';
import isEmpty from 'lodash/isEmpty';
const caroselDefaults = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  adaptiveHeight: false,
  autoplay: false,
  variableWidth: true,
  responsive: CAROUSEL_RESPONSIVE_SETTINGS,
};

const renderProducts = (productsArray, cardRenderer) => {
  return productsArray?.map(product => {
    return cardRenderer(product);
  });
};

const getMenuItemData = (id, product, itemFoodlineId) => {
  return {
    foodName: product?.productName[0]?.value,
    foodItemId: id,
    cartPrice: product?.productPrice,
    modifiers: [],
    quantity: 1,
    foodLineId: itemFoodlineId,
  };
};

const MenuItemList = props => {
  const {
    productList = [],
    cardType = '',
    tenantData = {},
    categoryId,
    categoryName,
    categoryUrl,
    catalogs,
    storeClosedData,
    setShowTopScrollBtn,
  } = props;
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  const { ADD_TO_CART_CLICK, PLP_PDP_DETAILS, MINI_PDP_DATA, FROMFLAGPLP } = START_ORDER_CONSTANTS;
  const { PlpProductCard = {} } = props.tenantData?.componentOptions || {};
  const { RESET_MODGROUP_IDS_UPDATE } = MENU_PDP_PAGE_CONSTANTS;

  const [caroselCount, setCaroselCount] = useState(1);
  const dispatch = useDispatch();
  const cartReducer = useSelector(data => data.cartReducer);
  const { flatResponse: { productMapById = {}, categoryMapById = {} } = {} } =
    useSelector(({ menuReducer }) => menuReducer) ?? {};
  const { cartData = {} } = getValueOrDefaultObject(cartReducer);
  const userParams = useSelector(data => data.appStateReducer?.userStatus);
  const [selectedCat, setSelectedCat] = useState(props.selectedCat);
  const [localizationFlow, setLocalizationFlow] = useState(false);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const [activeId, setActiveId] = useState(null);
  const { showCartAlert } = FoodItemListHandlers(
    undefined,
    undefined,
    undefined,
    undefined,
    userOrderStateDispatch,
    dispatch,
    undefined,
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setLocalizationFlow(false);
  });

  //Analytic AddToCart for non-customizable product KRM-14026
  const { addToCartAnalyticsOnly } = FoodItemListHandlers(
    { cartId: cartData?.id },
    tenantData?.tenantId,
    undefined,
    productMapById,
    undefined,
    dispatch,
    undefined,
  );
  //modify this before finalization
  // duplicate exists in organisms/CartPage/Presentation/ReusableComponents/RecomendationItem.js
  const clickHandler = (event, customizable, categoryDetails, productDetailsData) => {
    const { id, itemCount, product, itemFoodlineId } = productDetailsData;
    const { catId } = categoryDetails;
    const { id: category_id = '', name: category_Name = '', url: category_Url = '' } = categoryMapById?.[catId] ?? {};
    event && event.stopPropagation();
    setActiveId(id);
    if (userParams.localized) {
      if (customizable) {
        setSelectedCat(catId);
        userOrderStateDispatch({
          type: MINI_PDP_DATA,
          value: { id: id, flag: FROMFLAGPLP, foodLineId: '' },
        });
        //Customization Modal
        userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
        dispatch(
          fetchItemDetailsAction({
            tenantId: tenantData.tenantId,
            catalogName: catalogs,
            itemId: id,
          }),
        );
      } else if (itemCount === 0) {
        dispatch(
          addItemToCartAction(
            {
              params: {
                basketId: cartReducer?.cartData?.id,
              },
              tenantId: tenantData.tenantId,
            },
            [
              {
                Id: id,
                categoryId: category_id,
                quantity: itemCount + 1,
                modGrps: [],
                categoryName: category_Name,
                categoryUrl: category_Url,
              },
            ],
          ),
        );
        dispatch(setUserLastActiveTime(new Date()));
        //Analytic event for non-customizable items
        addToCartAnalyticsOnly(
          getMenuItemData(id, product, itemFoodlineId),
          QUANTITY_ACTION.Increase,
          tenantData.currencyConversionFactor,
        );
      } else if (itemCount > 0) {
        dispatch(
          updateItemQuantityAction(
            {
              params: {
                basketId: cartReducer?.cartData?.id,
                basketLineItemId: itemFoodlineId,
              },
              tenantId: tenantData.tenantId,
            },
            {
              quantity: itemCount + 1,
            },
          ),
        );
        dispatch(setUserLastActiveTime(new Date()));
        //Analytic event for non-customizable items
        addToCartAnalyticsOnly(getMenuItemData(id, product, itemFoodlineId), QUANTITY_ACTION.Increase);
      }
    } else {
      setLocalizationFlow(true);
      userOrderStateDispatch({
        type: ADD_TO_CART_CLICK,
        value: {
          addToCart: true,
          productItemId: id,
          categoryId: categoryId,
          oldProduct: product,
          customizable: customizable,
          catalogs: catalogs,
          fromPdpPage: false,
        },
      });
    }
  };
  const clickHandlerWrapper = (event, customizable, categoryDetails, productDetailsData) => {
    if (userParams.localized && isEmpty(cartReducer?.cartData?.id)) {
      //RENEGBL-91
      const { id, itemCount } = productDetailsData;
      const addItemList = [{ Id: id, categoryId: categoryId, quantity: itemCount + 1, modGrps: [] }];
      const shouldAddItem = true;
      dispatchCreateBasketsAction(
        dispatch,
        createBasketsAction,
        tenantData?.tenantId,
        userOrderState,
        cartReducer?.qrCodeScanTime,
        shouldAddItem,
        addItemList,
      );
    } else {
      clickHandler(event, customizable, categoryDetails, productDetailsData);
    }
  };
  const currentItemDetails = useSelector(({ menuReducer }) => menuReducer?.currentItemDetails);
  useEffect(() => {
    if (currentItemDetails && selectedCat && userOrderState.minipdpData.itemId === currentItemDetails.id) {
      //to set flag in cartReducer
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: selectedCat,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetails]);

  //modal open for multiple customization
  const openAlertModal = () => {
    showCartAlert(true);
  };

  const settings = {
    ...caroselDefaults,
    beforeChange: (current, next) => {
      setCaroselCount(Math.round(next + 1));
    },
    variableWidth: false,
  };

  const onCardClickHandler = (event, productDetailsData, customizable, categoryDetails) => {
    const { catId, catName, catUrl } = categoryDetails;
    const { productId, productInfo } = productDetailsData;
    event.preventDefault();
    event.stopPropagation();
    const ProductDetails = {
      productId,
      customizable,
      catId,
      catalogName: catalogs,
      productInfo: productInfo,
      isFromPlp: true,
      categoryName: catName,
      categoryUrl: catUrl,
    };
    userOrderStateDispatch({
      type: PLP_PDP_DETAILS,
      value: ProductDetails,
    });
    localStorage.setItem(PRODUCT_DETAILS, JSON.stringify(ProductDetails));
    props.history.push({
      pathname: `/pdp/${categoryId}/${productId}`,
    });
  };

  const addItemToFavourite = (tenantId, data, customerId) => {
    dispatch(
      addItemToFavouriteAction(
        {
          tenantId,
          customerId,
        },
        data,
      ),
    );
  };

  const removeItemFromFavourite = (tenantId, customerId, itemId) => {
    dispatch(
      addItemToUnFavouriteAction({
        tenantId,
        customerId,
        itemId,
      }),
    );
  };

  const cardRenderer = (product = {}) => {
    const {
      items: [item],
    } = product;
    const additionalProperties = jsontoObjects(item.additionalProperties);
    return (
      <MenuCard
        item={item}
        key={item.id}
        activeId={activeId}
        cardId={item.id}
        cardType={cardType}
        configureOptions={PlpProductCard}
        tenantData={tenantData}
        servingCount={additionalProperties.servings}
        button={product.button}
        categoryId={categoryId}
        categoryName={categoryName}
        categoryUrl={categoryUrl}
        clickHandler={clickHandlerWrapper}
        customizable={item.customizable}
        onCardClickHandler={onCardClickHandler}
        userParams={userParams}
        openAlertModal={openAlertModal}
        storeClosedData={storeClosedData}
        addFavourite={addItemToFavourite}
        removeFavourite={removeItemFromFavourite}
        setShowTopScrollBtn={setShowTopScrollBtn}
        data-testid='menu-card-component'
        {...additionalProperties}
        {...item}
      />
    );
  };

  return (
    <div className='product-container'>
      {localizationFlow && <UserLocalization />}
      {cardType === 'carousal' ? (
        <>
          <div className='individual-card-counter'>
            {caroselCount}/{productList.length}
          </div>
          <CarauselComp settings={settings}>{renderProducts(productList, cardRenderer)}</CarauselComp>
        </>
      ) : (
        renderProducts(productList, cardRenderer)
      )}
    </div>
  );
};

export default withRouter(MenuItemList);
